
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1105Grid extends Serenity.EntityGrid<Report_1105Row, any> {
        protected getColumnsKey() { return Report_1105Columns.columnsKey; }
        protected getDialogType() { return Report_1105Dialog; }
        protected getIdProperty() { return Report_1105Row.idProperty; }
        protected getInsertPermission() { return Report_1105Row.insertPermission; }
        protected getLocalTextPrefix() { return Report_1105Row.localTextPrefix; }
        protected getService() { return Report_1105Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected createQuickSearchInput() {
        }

        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
    
            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
                
            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });
    
            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["  "]);
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        }

        protected createSlickGrid() {
            var grid = super.createSlickGrid();

            // need to register this plugin for grouping or you'll have errors
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            return grid;
        }

        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: Report_1105Service.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            
            let reportTitle = 'รายงานทะเบียนสมาชิก'

            // Max page width = 277
            let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
                //0: { field: "MbType", title: "ประเภทสมาชิก", cellWidth: 20 },
                0: { field: "MbId", title: "รหัสสมาชิก", cellWidth: 30 },
                1: { field: "MbNameT", title: "ชื่อสมาชิก", cellWidth: 40 },
                2: { field: "MbAccumPoint", title: "แต้มสะสม", cellWidth: 15, halign: 'right' },
                3: { field: "MbNearlyExpirePoint", title: "แต้มสะสมที่กำลังจะหมดอายุ", cellWidth: 40, halign: 'right' },
                4: { field: "MbExpirePointDate", title: "วันที่แต้มหมดอายุ", cellWidth: 40, halign: 'right' },
                //6: { field: "MbCardStatus", title: "สถานะบัตร", cellWidth: 40, halign: 'right' },
                5: { field: "MbExpireDate", title: "วันบัตรหมดอายุ", cellWidth: 40, halign: 'right' },
                6: { field: "MbProvince", title: "จังหวัด", cellWidth: 20, halign: 'right' },
                7: { field: "MbAmphur", title: "อำเภอ/เขต", cellWidth: 20, halign: 'right' },
                8: { field: "MbTumbol", title: "ตำบลแขวง", cellWidth: 20, halign: 'right' },
          
            }

            // buttons.push(GeniuzPOS.Common.Helpers.PdfExportHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     pageNumbers: true,
            //     // onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',
            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,

            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));

            // buttons.push(GeniuzPOS.Common.Helpers.PdfExportHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     //separator: true,
            //     pageNumbers: true,
            //     // onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
            //     autoPrint: true,
            //     output: "dataurlnewwindow",
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',

            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,

            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );

            buttons.push({
                title: 'ประเภทสมาชิก',
                cssClass: 'expand-all-button',
                onClick: () => this.view.setGrouping(
                    [{
                        formatter: x => 'ประเภทสมาชิก: ' + x.value + ' (' + x.count + ' items)',
                        getter: 'MbType'
                    }])
            });

            buttons.push({
                title: 'No Grouping',
                cssClass: 'collapse-all-button',
                onClick: () => this.view.setGrouping([])
            });
            

            return buttons;
        }
    }
}